/**
 * Rovnaka mnozina ako stlpec Vykonanie/Deadline (backend awaiting_user).
 *
 * @param {{ awaiting_user?: Array<{ id?: number }> } | null | undefined} ticket
 * @param {{ id?: number, role?: string, is_superuser?: boolean } | null | undefined} user
 */
export function isCurrentUserInCrmTicketAwaitingUser(ticket, user) {
  if (!ticket || user?.id == null) return false;
  if (user?.role === 'admin' || user?.is_superuser) return true;
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  if (roles.some((r) => (typeof r === 'string' ? r.toLowerCase() === 'admin' : String(r?.name || '').toLowerCase() === 'admin'))) {
    return true;
  }
  const awaiting = ticket.awaiting_user;
  if (!Array.isArray(awaiting)) return false;
  return awaiting.some((u) => Number(u?.id) === Number(user.id));
}

/**
 * @param {Array<Record<string, unknown>> | undefined} approvalRequests
 * @param {Array<{ id?: number, transition_type?: string, phase?: string }>} approvalStates
 */
export function isCrmApprovalLevelBlockedBySequence(approvalRequests, approvalStates, idx) {
  const levels = Array.isArray(approvalRequests) ? approvalRequests : [];
  const approvedStateIds = approvalStates
    .filter((s) => s.phase === 'approval' && s.transition_type === 'section_final')
    .map((s) => Number(s.id));
  for (let i = 0; i < idx; i += 1) {
    const prevId = Number(levels[i]?.approval_state_id ?? 0);
    if (!approvedStateIds.includes(prevId)) return true;
  }
  return false;
}
